module.exports = __webpack_public_path__ + "img/easywords_prod.091c66a5.png";